import { HostSum } from '../components/HeadMeta';

export enum Language {
  ru = 'ru',
  az = 'az'
}

export interface SEOData {
  title?: string | null;
  description?: string | null;
  h1?: string | null;
  asPath: string | null;
  hostSum: HostSum | null;
}
